import React, { Component } from "react";
import FormGroupContainer, { IControlState, ICommonProps } from "./FormGroupContainer";
import createRef from "assets/scripts/utils/createRef";
import StandardView from "assets/scripts/components/common/form/FormGroup/StandardView";
export { IControlState, ICommonProps };
export default class FormGroup extends Component {
    constructor() {
        super(...arguments);
        this._formGroupContainerRef = createRef();
    }
    render() {
        const { props } = this;
        const { children, ...otherProps } = props;
        return (<FormGroupContainer ref={this._formGroupContainerRef} {...otherProps}>
				{({ error, id, helpId, errorId, controlState }) => (<StandardView label={props.label} className={props.className} error={error} id={id} required={props.required} helpId={helpId} help={props.help} errorId={errorId}>
						{children(controlState)}
					</StandardView>)}
			</FormGroupContainer>);
    }
    touch() {
        if (this._formGroupContainerRef.value != null) {
            this._formGroupContainerRef.value.touch();
        }
    }
    untouch() {
        if (this._formGroupContainerRef.value != null) {
            this._formGroupContainerRef.value.untouch();
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/scripts/components/common/form/FormGroup/FormGroup.tsx